module.exports = __webpack_public_path__ + "static/img/client28_img.4e26eb2.png";